export const MEMORY_CARD_ICONS = [
  "🍉",
  "🍌",
  "🍏",
  "🍒",
  "🌶️",
  "🍓",
  "🥝",
  "🫐",
  "🍑",
  "🥕",
  "🍆",
  "🍇",
  "🍍",
  "🍊",
  "🍋",
  "🥥",
  "🥭",
  "🍎",
  "🍈",
  "🥑",
  "🥦",
  "🍄",
  "🥬",
  "🌽",
  "🫑",
  "🥔",
];
